import React from "react";
import "../styles/WhyChooseUs.css";
import {
  FaLightbulb,
  FaUsers,
  FaCogs,
  FaAward,
  FaLeaf,
  FaHandshake,
  FaGlobeAsia,
  FaChartLine,
} from "react-icons/fa";

const WhyChooseUs = () => {
  return (
    <section className="why-us" id="why-us">
      <h2 data-aos="fade-up">Why Choose Venturebiz?</h2>

      {/* Cards Section */}
      <div className="why-us-grid">
        <div className="why-card" data-aos="fade-up" data-aos-delay="100">
          <FaLightbulb className="why-icon" />
          <h3>Innovation-Driven</h3>
          <p className="why-us-card-description">
            Every solution is designed with creativity and technology at its core.
          </p>
        </div>

        <div className="why-card" data-aos="fade-up" data-aos-delay="200">
          <FaUsers className="why-icon" />
          <h3>Community-Focused</h3>
          <p className="why-us-card-description">We believe growth is strongest when it uplifts people and places.</p>
        </div>

        <div className="why-card" data-aos="fade-up" data-aos-delay="300">
          <FaCogs className="why-icon" />
          <h3>Trusted Expertise</h3>
          <p className="why-us-card-description">A diverse team with proven knowledge across multiple industries.</p>
        </div>

        <div className="why-card" data-aos="fade-up" data-aos-delay="400">
          <FaAward className="why-icon" />
          <h3>Long-Term Value</h3>
          <p className="why-us-card-description">
            We don’t just solve today’s problems; we prepare you for tomorrow.
          </p>
        </div>

        <div className="why-card" data-aos="fade-up" data-aos-delay="500">
          <FaLeaf className="why-icon" />
          <h3>Sustainable Impact</h3>
          <p className="why-us-card-description">Every solution is built for long-term growth and responsibility.</p>
        </div>

        <div className="why-card" data-aos="fade-up" data-aos-delay="600">
          <FaHandshake className="why-icon" />
          <h3>Client Partnerships</h3>
          <p className="why-us-card-description">We build trust through transparency, collaboration, and results.</p>
        </div>

        {/* New Card 1 */}
        <div className="why-card" data-aos="fade-up" data-aos-delay="700">
          <FaGlobeAsia className="why-icon" />
          <h3>Global Perspective</h3>
          <p className="why-us-card-description">
           We combine local expertise and global insights to help businesses expand confidently.
          </p>
        </div>

        {/* New Card 2 */}
        <div className="why-card" data-aos="fade-up" data-aos-delay="800">
          <FaChartLine className="why-icon" />
          <h3>Data-Driven Growth</h3>
          <p className="why-us-card-description">
            Every decision is backed by analytics for measurable, sustainable success.
          </p>
        </div>
      </div>

      {/* Promise Section */}
      <div className="promise" data-aos="fade-up" data-aos-delay="900">
        <h3>Our Promise</h3>
        <p>
          We believe in creating opportunities that transform businesses and
          strengthen communities. Whether it’s a startup seeking the right push,
          an institution building capability, or a community looking to connect -
          VPPL is the bridge between vision and achievement.
        </p>
        <a href="#contact" className="cta-btn">
          Let’s Begin Your Journey
        </a>
      </div>
    </section>
  );
};

export default WhyChooseUs;